module.exports = __webpack_public_path__ + "static/media/table_background_large.ec96ea6b.jpg";